import React from 'react'

import { ArrowRightIcon, HeadingXSmall, BodyText, Label } from '@pb/components'
import { differenceInCalendarDays } from 'date-fns'
import { withRouter } from 'react-router-dom'

import { ACCOUNT_ROUTES, TRACKING_EVENTS } from 'App/constants'
import useTracking from 'hooks/useTracking'

import { MESSAGE_TYPES } from '../../constants'
import styles from './Message.scss'

const getLabelsForMessageType = (messageType): any => {
  switch (messageType) {
    case MESSAGE_TYPES.NEW_INVOICE.id:
      return {
        heading: 'omni.myaccount.inbox.new.invoice.due.soon.heading',
        text: 'omni.myaccount.inbox.new.invoice.due.soon.text',
      }
    case MESSAGE_TYPES.MONTHLY_INVOICE_DUE_SOON.id:
      return {
        heading: 'omni.myaccount.inbox.monthly.invoice.due.soon.heading',
        text: 'omni.myaccount.inbox.monthly.invoice.due.soon.text',
      }
    case MESSAGE_TYPES.ORDER_DUE_SOON.id:
      return {
        heading: 'omni.myaccount.inbox.invoices.due.soon.heading',
        text: 'omni.myaccount.inbox.monthly.invoice.due.soon.text',
      }
    default:
      return {
        heading: '',
        text: '',
      }
  }
}

const getTimeAgo = (date): any => {
  const differenceInDays = differenceInCalendarDays(new Date(), date)

  if (differenceInDays === 0) {
    return <Label copyKey="omni.myaccount.inbox.monthly.invoice.due.soon.date" />
  }
  if (differenceInDays < 7) {
    return (
      <Label
        copyKey="omni.myaccount.inbox.invoices.due.soon.date"
        replacements={differenceInDays}
      />
    )
  }
  const differenceInWeeks = Math.floor(differenceInDays / 7)
  return (
    <Label
      copyKey="omni.myaccount.inbox.new.invoice.due.soon.date"
      replacements={differenceInWeeks}
    />
  )
}

const Message: React.FC<any> = ({
  message,
  markMessageAsRead,
  setOmniCreditTabToTodo,
  hideInbox,
  history,
}) => {
  const { messageType } = message
  const labels = getLabelsForMessageType(messageType)
  const trackInboxView = useTracking(TRACKING_EVENTS.inboxView.id)

  const handleMessageClick = (): any => {
    trackInboxView({
      external_type: MESSAGE_TYPES[messageType].label,
    })
    markMessageAsRead()
    hideInbox()
    setOmniCreditTabToTodo()
    history.push(ACCOUNT_ROUTES.HMPay.path)
  }

  return (
    <li className={styles.container}>
      <button className={styles.message} type="button" onClick={handleMessageClick}>
        <HeadingXSmall
          Tag="h5"
          className={`${styles.messageHeading} ${!message.read ? styles.hasBadge : ''}`}
        >
          <Label copyKey={labels.heading} />
        </HeadingXSmall>
        <BodyText className={styles.text}>
          <Label copyKey={labels.text} />
        </BodyText>
        <BodyText className={styles.date}>{getTimeAgo(new Date(message.occurredTime))}</BodyText>
        <ArrowRightIcon size="small" className={styles.arrowRightIcon} />
      </button>
    </li>
  )
}

export default withRouter(Message)
